module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am709-a2722f75bb1a8d82cc974f4bc7bbe384.jpg";